import { Component, Inject, OnInit } from '@angular/core';
import { BixComfirmComponent } from '../bix-comfirm/bix-comfirm.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mfa-confirm-dialog-component',
  templateUrl: './mfa-confirm-dialog-component.component.html',
  styleUrls: ['./mfa-confirm-dialog-component.component.scss']
})
export class MfaConfirmDialogComponentComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<MfaConfirmDialogComponentComponent>, @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
  }

   close(result: boolean): void {
    this.dialogRef.close(result);
  }
}
